import { useAccount, useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

const useToken = (): [() => Promise<string>] => {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);

    const getToken = async () => {
        if (account) {
            const tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account,
            });
            return tokenResponse.accessToken;
        }
        return '';
    };

    return [getToken];
};

export default useToken;